import React from "react";
import { Container } from "@material-ui/core";
import { Grid } from "@material-ui/core";

import Heading from '../../Components/sectionHeading'
import FeaturesCard from '../../Components/FeaturesCard/featuresCard'

import aboutimg from '../../images/logo.png'
import ern from '../../images/ern.png'
import watch from '../../images/watch.png'
import fish from '../../images/fish.png'
import burn from '../../images/burn.png'
import liquidity from '../../images/liquidity.png'
import community from '../../images/community.png'
import featureimg from '../../images/featureimg.png'


const Feature = () => {
  return (
    <div id="features">
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="QMF---About py-md-5 my-5"
          style={{position:'relative'}}
        >
          <Grid
              xs={12}
              className="mb-5 pb-3"
          >
            <Heading 
                title="Features"
                // subtitle="Big Vision Great Features."
            />
          </Grid>
          <img src={featureimg} className="img-fluid Moon---FeatureImg" />
          <FeaturesCard
            img = {ern}
            title = "Earn $FTM by hodling $FMF"
            details1 = "6% of all transactions are redistributed in $FTM to all holders meeting the $FMF token holding requirement, this process is done automatically and your mileage can be observed via the dashboard. Accumulate $FTM by hodling the $FMF token!"
          />
          <FeaturesCard
            img = {watch}
            title = "Auto Paid Twice a Day"
            details1 = "For the first time ever, you don’t need to claim your earned $FTM. It’s automatically sent to your wallet roughly twice everyday."
          />
          <FeaturesCard
            img = {fish}
            title = "Anti-Dump Lock & 12% Sell Fee"
            details1 = "Sells are restricted to less than 0.1% of the total supply + 12% fee is applied to all sells. This will allow us to reduce swing-trading and break whales' control."
          />
          <FeaturesCard
            img = {burn}
            title = "Token Burn"
            details1 = "2% of every transaction is used to buy back FMF tokens and have them burnt forever thus decreasing the total supply and making the token hyper-deflationary!"
          />
          <FeaturesCard
            img = {liquidity}
            title = "Automatic Liquidity Pool"
            details1 = "2% of every transaction contributes to the liquidity pool thus automatically generating further liquidity on SpookySwap. bringing sustainability for $FMF holders in the long run."
          />
          <FeaturesCard
            img = {community}
            title = "Built for the Community"
            details1 = "$FMF is a community driven token built on the Fantom network."
          />
        </Grid>
      </Container>
    </div>
  );
}

export default Feature;
